import {
  ErrorMessageEn,
  ErrorMessageEs,
  SuccessMessageEn,
} from '../../../../constants/alerts';
import { successHandler, errorHandler } from '../../../utils';
import {
  CandidateLanguageBuilder,
  DeleteCandidateLanguageInput,
} from '../candidate-language.types';

export const deleteCandidateLanguage = (builder: CandidateLanguageBuilder) =>
  builder.mutation<void, DeleteCandidateLanguageInput>({
    query: ({ id }) => ({
      url: `/candidate-languages/delete/${id}`,
      method: 'DELETE',
    }),
    invalidatesTags: (result, error, { id }) => [
      { type: 'candidateLanguages', id },
      'Score',
    ],
    transformResponse: (response, meta, { lang }) => {
      successHandler(
        lang === 'en'
          ? SuccessMessageEn.SuccessfullyDeleted
          : SuccessMessageEn.SuccessfullyDeleted,
        true
      );
    },
    transformErrorResponse: (error, meta, { lang }) => {
      errorHandler(
        '[deleteLanguage]',
        lang === 'es' ? ErrorMessageEs.DeleteError : ErrorMessageEn.DeleteError,
        error,
        true
      );
    },
  });
